import React, { useEffect, useState } from 'react';
import {
    Button,
    Grid,
    Typography,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    ButtonGroup
} from '@material-ui/core';
import { CSVLink } from 'react-csv';
import firebase from 'firebase/app';
import { useSelector } from 'react-redux';

const ReporteCSV = ({ eventoIndex, config }) => {
    const [allData, setAllData] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const [headers, setHeaders] = useState([]);
    const [tableRows, setTableRows] = useState([]);
    const [filtro, setFiltro] = useState('todos');
    const [mostrarTabla, setMostrarTabla] = useState(false);

    const itemsArray = Object.values(config.items || []);

    const eventParticipants = useSelector(
        (state) => state.registry.eventParticipants
    );


    useEffect(() => {
        const data = eventParticipants;
        const allRows = [];
        const headersSet = new Set();

        for (const id in data) {
            const p = data[id];
            if (p.statusPago?.status !== 'ok' || p.borrado) continue;

            const base = {
                id,
                Número: p.numero,
                Nombres: p.nombres,
                Apellidos: p.apellidos,
            };

            const entregado = !!p.entregaKit;

            for (const item of itemsArray) {
                const entregaItem = p.entregaKit
                    ? Object.values(p.entregaKit).find((e) => e.item.code === item.code)
                    : null;

                const estado = entregaItem ? 'Entregado' : 'No entregado';
                base[item.name] = estado;

                if (item.itemForm) {
                    for (const campo of item.itemForm) {
                        const valorCampo = entregaItem?.itemFormData?.[campo.iDCampo] || 'N/A';
                        base[campo.etiqueta] = valorCampo;
                        headersSet.add(campo.etiqueta);
                    }
                }

                base['Recibe'] = entregaItem?.recibePersona || 'N/A';
                base['Escaneado'] = entregaItem?.scanner ? 'Sí' : 'No';
                base['Hora Entrega'] = entregaItem?.date
                    ? new Date(entregaItem.date).toLocaleString()
                    : 'N/A';
                base['Usuario Entrega'] = entregaItem?.nombresUser
                    ? `${entregaItem.nombresUser} ${entregaItem.apellidosUser}`
                    : 'N/A';
            }

            allRows.push({ ...base, _entregado: entregado });
        }

        const dynamicHeaders = Array.from(headersSet).map((h) => ({ label: h, key: h }));
        const fullHeaders = [
            { label: 'Número', key: 'Número' },
            { label: 'Nombres', key: 'Nombres' },
            { label: 'Apellidos', key: 'Apellidos' },
            ...itemsArray.flatMap(item => [
                { label: item.name, key: item.name },
                ...(item.itemForm?.map(campo => ({ label: campo.etiqueta, key: campo.etiqueta })) || []),
                { label: 'Recibe', key: 'Recibe' },
                { label: 'Escaneado', key: 'Escaneado' },
                { label: 'Hora Entrega', key: 'Hora Entrega' },
                { label: 'Usuario Entrega', key: 'Usuario Entrega' },
            ])
        ];

        setAllData(allRows);
        setHeaders(fullHeaders);

    }, [eventoIndex, config, eventParticipants]);

    useEffect(() => {
        if (!mostrarTabla) return;

        const filtrado = allData.filter((d) => {
            if (filtro === 'todos') return true;
            if (filtro === 'entregados') return d._entregado;
            if (filtro === 'pendientes') return !d._entregado;
            return true;
        });

        const csv = filtrado.map(({ _entregado, id, ...rest }) => rest);

        const rows = filtrado.map((p, i) => (
            <TableRow key={p.id || i}>
                {headers.map((h) => (
                    <TableCell key={h.key}>{p[h.key]}</TableCell>
                ))}
            </TableRow>
        ));

        setCsvData(csv);
        setTableRows(rows);
    }, [filtro, allData, headers, mostrarTabla]);

    const manejarFiltro = (nuevoFiltro) => {
        setFiltro(nuevoFiltro);
        setMostrarTabla(true);
    };

    return (
        <div style={{ marginTop: 32 }}>
            <Grid container justify="center" spacing={2} style={{ marginBottom: 16 }}>
                <Grid item>
                    <ButtonGroup variant="contained">
                        <Button
                            color={filtro === 'pendientes' ? 'primary' : 'default'}
                            onClick={() => manejarFiltro('pendientes')}
                        >
                            Por entregar
                        </Button>
                        <Button
                            color={filtro === 'entregados' ? 'primary' : 'default'}
                            onClick={() => manejarFiltro('entregados')}
                        >
                            Entregados
                        </Button>
                        <Button
                            color={filtro === 'todos' ? 'primary' : 'default'}
                            onClick={() => manejarFiltro('todos')}
                        >
                            Todos
                        </Button>
                    </ButtonGroup>
                </Grid>

                {mostrarTabla && (
                    <Grid item>
                        <CSVLink data={csvData} headers={headers} filename={`reporte-kits-${eventoIndex}-${filtro}.csv`}>
                            <Button variant="contained" color="primary">
                                Descargar CSV
                            </Button>
                        </CSVLink>
                        <Button

                            onClick={() => setMostrarTabla(false)}
                        >
                            Cerrar reporte
                        </Button>

                    </Grid>
                )}
            </Grid>

            {!mostrarTabla && (
                <Typography
                    variant="h5"
                    align="center"
                    color="primary"
                    style={{
                        margin: 40,
                        color: '#ef4123',
                        fontWeight: 'bold',
                        fontFamily: 'Maven Pro, sans-serif'
                    }}
                >
                    Selecciona una opción para consultar y descargar el reporte de kits entregados
                </Typography>
            )}

            {mostrarTabla && (
                <>
                    <Typography variant="h6" align="center" gutterBottom>
                        Vista previa del reporte
                    </Typography>

                    <Paper style={{ overflowX: 'auto' }}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    {headers.map((h) => (
                                        <TableCell key={h.key}>{h.label}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>{tableRows}</TableBody>
                        </Table>
                    </Paper>
                </>
            )}
        </div>
    );
};

export default ReporteCSV;
